import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Buttons";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const ModalContent = ({ closeModal, handleContinue }) => {
  return (
    <ModalContainer>
      <ModalTitle>{Text.newTickets}</ModalTitle>
      <ModalText>{Text.newTicketSubtext}</ModalText>
      <ButtonContainer>
        <Button
          label="Continue"
          variant="outlined"
          backgroundColor={Colors.white}
          size="large"
          fontColor={Colors.aqua}
          padding={"0.5rem 0.5rem"}
          cursorType="pointer"
          onClick={handleContinue}
        />
        <Button
          label="Cancel"
          variant="filled"
          backgroundColor={Colors.aqua}
          size="large"
          fontColor={Colors.white}
          padding={"0.5rem 0.5rem"}
          cursorType="pointer"
          onClick={closeModal}
        />
      </ButtonContainer>
    </ModalContainer>
  );
};

const ModalContainer = styled.div`
  text-align: center;
  padding: 1rem;
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-family: Poppins;
`;

const ModalText = styled.p`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-family: Poppins;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export default ModalContent;
